import React from 'react';
import { Icon } from '@chargify/icons';
import { KEYBOARD_KEYS } from '../../../constants';
import { CheckboxState, Status } from './types';
import { CheckboxWrapper, Label } from './Checkbox.styles';

export type CheckboxProps = {
  label: string | (() => JSX.Element);
  onChange?: (res: boolean) => void;
  value: boolean;
  isDisabled?: boolean;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'>;

const Checkbox = ({
  /**
   * The value of the checkbox
   */
  value,
  /**
   * The onChange handler for the checkbox
   */
  onChange,
  /**
   * The label for the checkbox
   */
  label,
  /**
   * The disabled state of the checkbox
   */
  isDisabled,
  ...rest
}: CheckboxProps) => {
  const state = `${value ? 'checked' : 'unchecked'}`;
  const status: Status = `${isDisabled ? 'disabled' : 'active'}`;
  const variant = `${state}-${status}` as CheckboxState;

  const handleChange = () => {
    if (!isDisabled && onChange) {
      onChange(!value);
    }
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.code === KEYBOARD_KEYS.SPACE) {
      handleChange();
    }
  };
  const labelContent = typeof label === 'function' ? label() : label;
  return (
    <Label
      status={status}
      aria-checked={value}
      onKeyDown={handleKeyDown}
      isDisabled={isDisabled}
      tabIndex={0}
      role={'checkbox'}
    >
      <CheckboxWrapper size={'default'} variant={variant} isChecked={value}>
        <Icon fill={'white.main'} type={'check'} />
        <input
          hidden
          type="checkbox"
          onChange={handleChange}
          checked={value}
          {...rest}
        />
      </CheckboxWrapper>
      {labelContent}
    </Label>
  );
};
export default Checkbox;
